import { useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import {
  ColDef,
  GridReadyEvent,
  IDatasource,
  IGetRowsParams,
} from "ag-grid-community";
import { themeGridWidgets } from "../../../../themeGrid";
import { localeText } from "../../../../localeTextFromGrid";
import styles from "./styles.module.scss";

interface IGridBaseWidgetProps {
  columns: ColDef[];
  fetchData: (params: IGetRowsParams) => Promise<void>;
  loading: boolean;
}

export function GridBaseWidget({
  fetchData,
  loading,
  columns,
}: IGridBaseWidgetProps) {
  const gridRef = useRef<AgGridReact<any>>(null);

  const getDataSource = (): IDatasource => {
    return {
      getRows: (params) => {
        fetchData(params);
      },
    };
  };

  const onGridReady = (params: GridReadyEvent) => {
    params.api.setGridOption("datasource", getDataSource());
  };

  useEffect(() => {
    const api = gridRef.current?.api;
    if (api && api.setGridOption) {
      api.setGridOption("datasource", getDataSource());
    }
  }, []);

  return (
    <div className={`${styles.dataGridContainer}`}>
      <AgGridReact
        ref={gridRef}
        theme={themeGridWidgets}
        localeText={localeText}
        loading={loading}
        columnDefs={columns}
        overlayNoRowsTemplate="<span style='color: #616161;'>Nenhum dado encontrado.</span>"
        defaultColDef={{
          sortable: false,
          editable: false,
          filter: false,
          floatingFilter: false,
          resizable: true,
        }}
        suppressCellFocus={true}
        headerHeight={25}
        rowStyle={{ border: "0" }}
        containerStyle={{ border: "0" }}
        cacheBlockSize={10}
        maxBlocksInCache={1}
        onGridReady={onGridReady}
        rowModelType="infinite"
        animateRows={true}
      />
    </div>
  );
}
